import { existsModule } from "@/hooks/modulesUtils"

let webusers = [{
    header: 'Management',
    resource: 'home',
    action: 'read'
},
{
    title: 'Students',
    icon: 'UsersIcon',
    children: [
        {
            title: 'Students',
            route: 'students',
            resource: 'student',
            action: 'read'
        },
        {
            title: 'Enrollments',
            route: 'enrollments',
            resource: 'enrollment',
            action: 'read'
        },
    ]
},
{
    title: 'Courses',
    icon: 'BriefcaseIcon',
    children: [
        {
            title: 'Courses',
            route: 'courses',
            resource: 'course',
            action: 'read'
        },
        {
            title: 'Sections',
            route: 'sections',
            resource: 'section',
            action: 'read'
        }
    ]
},
{
    title: 'Products',
    icon: 'ArchiveIcon',
    children: [
        {
            title: 'Products',
            route: 'products',
            resource: 'product',
            action: 'read'
        },
        {
            title: 'Families',
            route: 'families',
            resource: 'family',
            action: 'read'
        },
    ]
},


]


if (existsModule('Academy')) webusers.push({ title: 'Teachers', route: 'teachers', icon: 'UsersIcon', resource: 'teacher', action: 'read' })
if (existsModule('Academy')) webusers.push({ title: 'Classrooms', route: 'classrooms', icon: 'CalendarIcon', resource: 'classroom', action: 'read' })
if (existsModule('Academy')) webusers.push({ title: 'Lessons', route: 'lessons', icon: 'BookIcon', resource: 'lesson', action: 'read' })

export default webusers
